var map = {
	"./addliquidity.json": 1148,
	"./box.json": 1149,
	"./components.json": 1150,
	"./constants.json": 1151,
	"./error.json": 1152,
	"./farm.json": 1153,
	"./home.json": 1154,
	"./launchpad.json": 1155,
	"./menu.json": 1156,
	"./minning.json": 1157,
	"./nft.json": 1158,
	"./pool.json": 1159,
	"./referral.json": 1160,
	"./removeliquidity.json": 1161,
	"./rolling.json": 1162,
	"./swap.json": 1163,
	"./team.json": 1164,
	"./uikit.json": 1165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1147;